// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__28bNQ","size20":"styles_size20__KKIcF","size14":"styles_size14__1WKwM","alignRight":"styles_alignRight__1swN0","noTopMargin":"styles_noTopMargin__1j78t"};